<template>
  <div id="DataAnalysis">
    <div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-row class="pl-4 pt-4 pr-4">
          <van-col span="24">
            <div class="demo-content">
              <h5>{{ getWork().work.WorkName }}</h5>
              <p class="text-desc" v-if="ExamData.AreaContrast">
                当前考区下有
                <b>{{ExamData.AreaContrast.length}}</b>个地区
              </p>
            </div>
          </van-col>
        </van-row>

        <!-- 时间场次组件 -->
        <time-field @callback="setExamInfo"></time-field>

        <van-collapse v-model="active" class="pt-2 text-left">
          <van-collapse-item
            class="mobile-nav_item border-1 mb-2"
            v-for="(item,index) in ExamData.AreaContrast"
            :key="index"
            :name="index"
          >
            <template slot="title">
              <dl>
                <!-- 考区名称 -->
                <dt>
                  <van-icon name="map-marked" size="16px" class="mr-1" />
                  <span class="text-bold">{{item.AreaName}}</span>
                  <small class="color-gray">
                    工作人员
                    <b>{{item.WorkerNum}}</b>人
                  </small>
                </dt>
                <!-- 数据统计 -->
                <dd>
                  {{item.AreaName}}考区报名考生
                  <b>{{item.StuNum}}</b>
                  人,上报缺考 {{item.AbsentNum}}人,实际参加考试 {{item.TakeNum}}人,实考率为
                  <b>{{ parseInt(parseInt(item.TakeNum) / parseInt(item.StuNum) * 100) }}</b>
                  %,占 {{item.AddrNum}}个考点,共设有 {{ item.RoomNum }}个考场.
                </dd>
              </dl>
            </template>
            <div>
              <dl v-for="(e,i) in item.AddrList" :key="i">
                <dt>
                  <van-icon name="location-o" size="16px" class="mr-1" />
                  <span class="color-dark">{{ e.AddrName }}</span>
                </dt>
                <dd style="margin:1rem;">
                  {{ e.AddrName }}考点,报名考生
                  <b>{{ e.StuNum }}</b>
                  人,上报缺考 {{ e.AbsentNum }}人,实际参加考试 {{e.TakeNum}}人,实考率为
                  <b>{{ parseInt(parseInt(e.TakeNum) / parseInt(e.StuNum) * 100) }}</b>
                  %,设有考场{{ e.RoomNum }}间
                </dd>
              </dl>
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import timeField from "@/components/TimeField.vue";
export default {
  name: "DataAnalysis",
  data() {
    return {
      isLoading: false,
      active: [0],
      ExamData: {},
      TimeArray: [],
      DefaultSelectTime: "",
      SelectAreaIndex: 0
    };
  },
  components: {
    timeField
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$toast("刷新成功");
        this.isLoading = false;
        this.count++;
      }, 500);
    },
    //设置考试场次信息
    setExamInfo: function() {
      this.workInfo = this.getWork();
      //eslint-disable-next-line
      console.log(this.getWork().work.WorkID, this.getExamTime().beginTime);
      this.apiDataAnalysisGet(
        {
          WorkID: this.getWork().work.WorkID,
          BeginTime: this.getExamTime().beginTime
        },
        this,
        e => {
          //eslint-disable-next-line
          console.log(e);
          this.ExamData = e;
        }
      );
    },
    //退出考试
    Exit() {
      this.removeWork();
      this.$router.push({ name: "ExamManage" });
    }
  },
  created() {
    //如果已选择考试工作任务的话在此页中显示考试工作任务种的场次列表
    if (this.getWork()) {
      this.setExamInfo();
    }
  }
};
</script>

<style scoped>
</style>
